import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useTable } from 'react-table'
import { withAuthHeader } from '../../routes/authRequest';
import routes from '../../routes/routes';

const SectionTableComponent = ({ data: tableData, header }) => {
    // console.log(tableData, header);
    const [events, setEvents] = useState('')

    useEffect(() => {
        withAuthHeader.get(routes.api.locations.getSection)
            .then(res => {
                setEvents(res.data.data)
                console.log(res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
    }, [])
    const data = React.useMemo(
        () => events || [],
        [events]
    )

    const columns = React.useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name', // accessor is the "key" in the data
            },
            {
                Header: 'Category',
                accessor: 'category',
            },
            {
                Header: 'Price',
                accessor: 'price',
            },
            {
                Header: 'Description',
                accessor: 'description',
            },
        ],
        []
    )
    const tableInstance = useTable({ columns, data })

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance

    const deleteSection = (id) => {
        // console.log(id);
        withAuthHeader.post(routes.api.locations.deleteSection, { id })
            .then(res => {
                setEvents(events.filter((event) => event.id !== id))
                console.log(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    }
    return (
        // apply the table props
        <table {...getTableProps()} className="table table-hover table-responsive">
            <thead className="thead-dark">
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th
                                {...column.getHeaderProps()}
                            >
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return (
                                    <td
                                        {...cell.getCellProps()}
                                    >
                                        {cell.render('Cell')}
                                    </td>
                                )
                            })}
                            <td>
                                <Link to={
                                    {
                                        pathname: routes.public.editSection,
                                        state: { section: row.original }
                                    }}
                                    class="btn btn-default"
                                >
                                    Edit
                                </Link>
                            </td>
                            <td>
                                <button
                                    class="btn btn-danger"
                                    onClick={(event) =>deleteSection(row.original.id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default SectionTableComponent
